import { render, staticRenderFns } from "./ThirdPartyServiceViewGlobal.vue?vue&type=template&id=95c6cd3c&"
import script from "./ThirdPartyServiceViewGlobal.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyServiceViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports